import type { UserSavedSearch } from "@/modules/jobAds/client/api/types"

import { useState } from "react"

import { createUserSavedSearch } from "@/modules/jobAds/client/api/createUserSavedSearch"
import { computeUserSavedSearch } from "@/modules/jobAds/client/utils/computeUserSavedSearch"
import { usePageContext } from "@/modules/jobSearch/components/PageContext/PageContextProvider"

export type UseAddUserSavedSearchReturn = {
  addUserSavedSearch: (searchParams: UserSavedSearch["searchParams"]) => Promise<void>
  isLoading: boolean
}

export const useAddUserSavedSearch = (): UseAddUserSavedSearchReturn => {
  const { updateUserSavedSearch } = usePageContext()
  const [isLoading, setIsLoading] = useState(false)

  const addUserSavedSearch = async (searchParams: UserSavedSearch["searchParams"]): Promise<void> => {
    setIsLoading(true)

    return createUserSavedSearch({
      attributes: JSON.stringify(searchParams),
    })
      .then(({ savedSearch }) => {
        if (savedSearch) {
          updateUserSavedSearch?.(computeUserSavedSearch(savedSearch))
        }
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  return { addUserSavedSearch, isLoading }
}
